import { render, staticRenderFns } from "./IndexDetail.vue?vue&type=template&id=8b1f2646&"
import script from "./IndexDetail.vue?vue&type=script&lang=js&"
export * from "./IndexDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports